import { MarketOrderTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/entries/MarketOrderTacticPanel';
import { MarketOrderWrapper } from '../../../../components/displays/tradeplans/softOrderModules/entryTacticModules/MarketOrderModule/wrapper/MarketOrderWrapper';
import MarketOrderDocs from '../../../../components/forms/tradeplans/documentation/MarketOrderDocumentation';
import MarketOrderModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/entryTactics/modules/MarketOrderModule';
import { MarketOrderData } from './marketOrderData';
import { validateMarketOrder } from './validateMarketOrder';




export const MarketOrder = {
  //data class
  dataStore: MarketOrderData,

  //string constants
  name: 'MARKET_ORDER',
  tacticLabel: 'Market Order',
  addTacticLabel: 'Add Market Order',
  category: 'Entry',

  // components
  tradePlanFormModule: MarketOrderModule,
  tacticPanel: MarketOrderTacticPanel,
  addTacticPanel: null,
  wrapper: MarketOrderWrapper,
  chartSoftOrderComponent: null,
  documentation: MarketOrderDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null, //todo
  validationFunction: validateMarketOrder,
};
